
import Selector from 'vux/src/components/selector/index.vue'

export default {
name: "reset-password",
components: {
Selector
},
data(){
return {
resetWay:'手机号',
mobile:null,
email:'',
}
},
methods:{
sendEmail(){

if( this.testPhone(this.resetWay) && this.testEmail() ){
const mobileReg = /^(\d{2}-)?1[345789]\d{9}$/;
const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\\w+)*\.\w+([-.]\w+)*$/;

let testMobile=mobileReg.test(this.mobile)
let testEmil=emailReg.test(this.email)
if(!testEmil){
this.$vux.toast.text('输入格式不正确，请重新输入');
return;
}
if(this.resetWay=="手机号"){
if(!testMobile){
this.$vux.toast.text('输入格式不正确，请重新输入');
return;
}
}

if(this.resetWay == "账号" ){
let param = {
login:this.mobile,
email:this.email
};
this.$post('api/before-login/password-reset-by-login?_allow_anonymous=true',param).then((result) => {
this.$vux.toast.text('邮件发送成功');
this.$router.push('/send-email-success')

}).catch(() => {

})
}else if(this.resetWay == "手机号"  ){
let param = {
phone:this.mobile,
email:this.email
};
this.$post('api/before-login/password-reset-by-phone?_allow_anonymous=true',param).then((result) => {
this.$vux.toast.text('邮件发送成功');
this.$router.push('/send-email-success')
}).catch(() => {
})
}

}



},
testPhone(value){
if(!this.mobile){
this.$vux.toast.text(`请填写${value}`);
return 0;
}else {
return 1;
}
},
testEmail(){
if(!this.email){
this.$vux.toast.text('请填写邮箱');
return 0;
}else{
return 1;
}
},
back(){
this.$router.go(-1);
}
}
}



// WEBPACK FOOTER //
// ./src/page/user/reset-password.vue